import React from "react";
import Navbar from "../parts/Navbar";
import Footer from "../parts/Footer";
import Newsletter from "../parts/Newsletter";

const Default = ({ title, children, noPadding, topBar }) => {
  window.document.title = title
    ? `${title} - Enabled By Design`
    : "Enabled By Design";
  return (
    <div className={`lDefault ${noPadding ? "noPadding" : ""}`}>
      <Navbar />
      <Newsletter />
      {topBar}
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Default;
